<mp-list-action-button [buttonLabel]="buttonLabel()" (buttonClicked)="toggleMaximizeList.emit()" />
